// This file is automatically generated. Do not edit it directly.
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://efvgrxgtjdsarvibjkap.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
  || import.meta.env.VITE_SUPABASE_ANON_KEY
  || 'sb_publishable_JK2Eas6deubpnbyDkvTC2Q_B6I6MRhj';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Singleton para evitar múltiplas instâncias do GoTrueClient (HMR/Vite,
// múltiplos imports). Usa storageKey distinto do client externo
// (src/lib/supabase.ts) para não conflitar.
const globalForInternal = globalThis as unknown as {
  __cz_internal_supabase__?: SupabaseClient<Database>
};

export const supabase: SupabaseClient<Database> =
  globalForInternal.__cz_internal_supabase__ ??
  createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: localStorage,
      storageKey: 'cz-internal-auth-token',
      persistSession: true,
      autoRefreshToken: true,
    }
  });

if (!globalForInternal.__cz_internal_supabase__) {
  globalForInternal.__cz_internal_supabase__ = supabase;
}
